module.exports = __webpack_public_path__ + "img/collect-img.7d311d15.png";